'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  light: _react.PropTypes.bool,
  dark: _react.PropTypes.bool,
  full: _react.PropTypes.bool,
  fixed: _react.PropTypes.string,
  color: _react.PropTypes.string,
  role: _react.PropTypes.string,
  tag: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
  className: _react.PropTypes.string,
  cssModule: _react.PropTypes.object
};

var defaultProps = {
  tag: 'nav',
  role: 'navigation'
};

var Navbar = function Navbar(props) {
  var _classNames;

  var className = props.className;
  var cssModule = props.cssModule;
  var light = props.light;
  var dark = props.dark;
  var full = props.full;
  var fixed = props.fixed;
  var color = props.color;
  var Tag = props.tag;

  var attributes = _objectWithoutProperties(props, ['className', 'cssModule', 'light', 'dark', 'full', 'fixed', 'color', 'tag']);

  var classes = (0, _utils.mapToCssModules)((0, _classnames2.default)(className, 'navbar', (_classNames = {
    'navbar-light': light,
    'navbar-dark': dark
  }, _defineProperty(_classNames, 'bg-' + color, color), _defineProperty(_classNames, 'navbar-full', full), _defineProperty(_classNames, 'navbar-fixed-' + fixed, fixed), _classNames)), cssModule);

  return _react2.default.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;

exports.default = Navbar;


//////////////////
// WEBPACK FOOTER
// ./~/reactstrap/lib/Navbar.js
// module id = 1488
// module chunks = 0